

import { Alert } from 'antd';
import React, { useCallback, useEffect ,useState} from 'react';

const ErrorMessage = ({ msg, onClose }) => {
  const [message, setMessage] = useState();
  useEffect(() => {
    if (msg) {
      setMessage(msg)
    }
  }, [msg])
  const closeErrorMessage = useCallback(() => {
    setMessage(null);
    if (onClose) {
      onClose();
    }
  },[])
  return (
    <div>
      {message && <Alert
        className="w-100 mb-4 banks-errmsg"
        type="error"
        description={message}
        showIcon
        onClose={closeErrorMessage}
        closable
      />}
    </div>
  );
};
export default ErrorMessage;

